import React from 'react';
import Auth from "./Auth"
import Config from "./Config"
import Event from "./Event"
import Log from "./Log"
import Request from "./Request"
import Util from "./Util"
import fitty from '../plugins/fitty';
import Alert from "./Alert";

class TB extends Util {
    static Auth = Auth;
    static ScopedAuth;
    static BugsnagClient;
    static middleware;

    static mq = window.matchMedia('(max-width: 720px)');


    static Request = Request;

    static fitty = fitty;


    /**
     * [Note]
     *
     * @param {Object} config
     * @returns void
     */
    static boot(config) {
        Config.boot(config);
        // Log.boot();

        if (config.auth) {
            this.ScopedAuth = config.auth;
        }

        if (this.isFunction(this.mq.addEventListener)) {
            this.mq.addEventListener('change', this.handleMediaQueryChange.bind(this));
        }
    }

    static handleMediaQueryChange = (mq) => {
        // matches will be true or false based on the value for the media query

        return this.event('App@IsMobileChange', mq.matches);
    };

    static setMiddleware = (middleware) => {
        this.middleware = middleware;
    }

    static isMobile() {
        return this.mq.matches
    }

    /**
     * [Note]
     *
     * @returns TB.Auth()
     */
    static auth() {
        if (this.ScopedAuth) {
            return this.ScopedAuth;
        }

        return this.Auth;
    }

    /**
     * [Note]
     *
     * @param {String} key
     * @returns {mixed}
     */
    static config(key) {
        return Config.get(key);
    }

    /**
     * [Note]
     *
     * @param {String} name
     * @param {Object} params
     * @returns Event
     */
    static event(name, params) {
        if (name) {
            return Event.fire(name, params);
        }

        return Event;
    }

    /**
     * [Note]
     *
     * @param {String} info
     * @returns {Log}
     */
    static log(info) {
        if (info) {
            Log.info(info);
        }

        return Log;
    }

    /**
     * [Note]
     *
     * @param url
     * @param {Object} params
     * @returns {Request}
     */
    static request(url, params = {}) {
        return this.Request.make(url, params);
    }

    /**
     * [Note]
     *
     * @param {String} url
     * @param {Object} params
     * @returns {Request}
     */
    static api_endpoint(url) {
        let host = this.config('api.host');
        if (!host) {
            return url;
        }
        return host + url;
    }

    /**
     * [Note]
     *
     * @param {String} message
     * @param {Object} options
     * @returns void
     */
    static async toast(message, options = {}) {
        if (message === false) {
            return this.event('Alert@hide');
        }

        let theme = options.theme;
        if (options.type) {
            switch (options.type) {
                case 'info':
                case 'warning':
                case 'error':
                    theme = options.type;
                    break;
                default:
                    break;
            }
        }


        return this.event('Alert@show', {
            theme,
            title: message
        });
    }

    /**
     * [Note]
     *
     * @returns Object
     */
    static routes() {
        return {
            clientProjectSetup: '/client/project/setup/:projectId',
            clientProjectBidding: '/client/project/bidding/:projectId',
            clientProjectActive: '/client/project/active/:projectId',
            clientProjectList: '/client/projects',
        }
    }

    /**
     * [Note]
     *
     * @returns void
     */
    static async showPermissionError() {
        return this.sysAlert('client.missing_group_permission_for_action')
    }
    /**
     * [Note]
     *
     * @returns void
     */
    static async showServerErrorToast() {
        return this.toast(
            'Something went wrong. Please try again later.',
            {'theme': 'danger'}
        )
    }

    /**
     * [Note]
     *
     * @param {String} message
     * @param {Object} options
     * @returns {String}
     */
    static storedPreferences() {
        let preferences = {};

        try {
            let storedPreferences = window.localStorage.getItem('user_preferences');

            if (storedPreferences) {
                preferences = JSON.parse(storedPreferences);
            }

        } catch (e) {
            console.warn("TB.storedPreferences", e)
        }
        return preferences;
    }

    /**
     * [Note]
     *
     * @returns void
     * @param store
     */
    static persistStoredPreferences(store = {}) {
        // console.log('TB @ persistStoredPreferences -> store', store);
        let storedPreferences = this.storedPreferences();
        // console.log('TB @ persistStoredPreferences -> storedPreferences', storedPreferences);

        try {
            let preferences = this.merge({...storedPreferences}, {...store});
            // console.log('TB @ persistStoredPreferences -> preferences', preferences);
            window.localStorage.setItem('user_preferences', JSON.stringify(preferences));

        } catch (e) {
            console.warn("Error storing preferences", e)
            return false;
        }

        return true;
    }

     /**
     * [Note]
     *
     * @returns void
     */
    static clearLocalStorage() {
         let storageToKeep = [...TB.config('authStorageKeys')];

         TB.map(TB.keys({...localStorage}), key => {
             if (TB.isString(key) && !storageToKeep.includes(key)) {
                 localStorage.removeItem(key)
             }
         });
     }

    /**
     * [Note]
     *
     * @returns void
     */
    static forceClearLocalStorage() {
        let storageToKeep = TB.filter([...TB.config('authStorageKeys')], key => !key?.includes?.('browse'));

        TB.map(TB.keys({...localStorage}), key => {
            if (TB.isString(key) && !storageToKeep.includes(key)) {
                localStorage.removeItem(key)
            }
        });
    }



    /**
     * [Note]
     *
     * @param {String} type
     * @returns {Promise}
     */
    static storedBrowseFilters(type = 'talent') {
        let preferences = {};

        try {
            let storedPreferences = window.localStorage.getItem(`browse${TB.startCase(type)}SideFilters`);

            if (storedPreferences) {
                preferences = JSON.parse(storedPreferences);
            }

        } catch (e) {
            console.warn("TB.storedPreferences", e)
        }
        return preferences;
    }
    /**
     * [Note]
     *
     * @param {String} type
     * @param {Object} value
     * @returns {Boolean}
     */
    static persistStoredBrowseFilters(type = 'talent', value = {}) {

        try {
            console.log('persistStoredBrowseFilters', value)
            window.localStorage.setItem(`browse${TB.startCase(type)}SideFilters`, JSON.stringify(value));
            return true;
        } catch (e) {
            console.warn("TB.storedPreferences", e)
        }
        return false;
    }

    /**
     * [Note]
     *
     * @param {String | Function} action
     * @returns {Promise}
     */
    static async handleAlertAction(action) {
        if (!action || !action.click) {
            return;
        }
        if (TB.isString(action.click)) {
            return window.location.replace(action.click)
        }
        if (TB.isFunction(action.click)) {
            await action.click();
        }
    }

    static async alert(type, title, message, actions, options) {
        let translationKey, theme, replace = {};

        if (TB.transOrFail('alerts.' + type + '.title')) {
            translationKey = type;
            if (typeof title === 'object') {
                replace = title;
                title = null;
            }
        }
        if (!Object.values(Alert.TYPES).includes(type)) {
            switch (type) {
                case 'error':
                case 'danger':
                    type = Alert.TYPES.ALERT;
                    break;
                case 'warning':
                    type = Alert.TYPES.CONFIRM;
                    theme = 'warning';
                    break;
                default:
                case 'success':
                    type = Alert.TYPES.CONFIRM;
                    break;
            }
        }

        if (Array.isArray(title)) {
            actions = title;
            title = null;
        } else if (TB.isString(title)) {
            title = TB.tryTrans(title);
        }

        if (Array.isArray(message)) {
            actions = message;
            message = null;
        } else if (TB.isString(message)) {
            message = TB.tryTrans(message);
        }

        if (Array.isArray(actions)) {
            actions = actions.map((action) => {
                let title = action.title ? this.tryTrans(action.title) : undefined;
                let onClick = action.click ? () => this.handleAlertAction(action) : undefined;

                return {
                    title,
                    onClick
                }
            })
        }


        return new Promise(async (resolve, reject) => {

            try {
                let alert = {
                    translationKey,
                    type,
                    theme,
                    title,
                    message,
                    actions,
                    onPositiveAction: () => resolve(true),
                    onNegativeAction: () => resolve(false),
                    onCloseAction: () => resolve(false),
                    replace,
                    preferenceKey: false
                };
                if (TB.isDefined(options) && TB.isObject(options)) {
                    for (let [key, value] of Object.entries(options)) {
                        if (TB.isDefined(alert[key])) {
                            alert[key] = value;
                        }
                    }
                }

                while (TB.AlertIsShowing) {
                    await this.event('Alert@hide');
                    await TB.wait(50);
                }

                this.event('Alert@show', alert);

            } catch (e) {
                console.warn("TB@alert", e)
            }
        })
    }

    static sysAlert(translationKey, replace = {}, options = {}) {

        return new Promise(async (resolve, reject) => {

            try {
                if (!TB.has(laravel.alerts, translationKey)) {

                    console.warn("Cant find translation key", translationKey)
                    return this.alert(translationKey)
                }

                replace = {
                    ...replace,
                    max_candidates: parseInt(laravel.platform_settings.Max_Candidates_Per_BYO_Project_Role) || 10
                }
                let model = TB.get(laravel.alerts, translationKey);

                if (model.positive) {
                    model.positiveTitle = model.positive
                }
                if (model.negative) {
                    model.negativeTitle = model.negative
                } else {

                }

                for (let paramKey in replace) {
                    model.message = _.replace(model.message, `:${paramKey}`, replace[paramKey]);
                    model.title = _.replace(model.title, `:${paramKey}`, replace[paramKey]);
                }

                let alertModel = {
                    // translationKey,
                    ...model,
                    onPositiveAction: () => resolve(true),
                    onNegativeAction: () => resolve(false),
                    onCloseAction: () => resolve(false),
                    replace,
                    ...options
                };


                if (!alertModel.type) {
                    switch (alertModel.theme) {
                        case 'error':
                        case 'danger':
                            alertModel.type = Alert.TYPES.ALERT;
                            break;
                        case 'warning':
                            alertModel.type = Alert.TYPES.CONFIRM;
                            alertModel.theme = 'warning';
                            break;
                        default:
                        case 'success':
                            alertModel.type = Alert.TYPES.CONFIRM;
                            break;
                    }
                }


                while (TB.AlertIsShowing) {
                    await this.event('Alert@hide');
                    await TB.wait(50);
                }

                this.event('Alert@show', alertModel);

            } catch (e) {
                console.warn("TB@alert", e)
            }
        })
    }

    static AlertIsShowing = false;

    static alertShowing() {
        return this.AlertIsShowing;
    }

    static isClassComponent(component) {
        return (
            typeof component === 'function' &&
            !!component.prototype.isReactComponent
        )
    }

    static isFunctionComponent(component) {
        return (
            typeof component === 'function' &&
            String(component).includes('return React.createElement')
        )
    }

    static isReactComponent(component) {
        return (
            this.isClassComponent(component) ||
            this.isFunctionComponent(component)
        )
    }

    static isElement(element) {
        return React.isValidElement(element);
    }

    static isDOMTypeElement(element) {
        return this.isElement(element) && typeof element.type === 'string';
    }

    static tryObject(object) {
        return {...(object || {})}
    }

    static tryArray(array) {
        return [...(array || [])]
    }

    static mapClass(classNames, classProps = {}) {

        if (typeof classNames === 'object') {
            classProps = {...classNames};
            classNames = ''
        }

        classNames += ' ';

        for (let [name, active] of Object.entries(classProps)) {
            if (active) {
                classNames += name;
                classNames += ' '
            }
        }
        return classNames
    }

    isJSON(str) {
        try {
            return (JSON.parse(str) && !!str);
        } catch (e) {
            return false;
        }
    }

    static objectToQueryString(initialObj) {
        const reducer = (obj, parentPrefix = null) => (prev, key) => {
            const val = obj[key];
            key = encodeURIComponent(key);
            const prefix = parentPrefix ? `${parentPrefix}[${key}]` : key;

            if (val == null || typeof val === 'function') {
                prev.push(`${prefix}=`);
                return prev;
            }

            if (['number', 'boolean', 'string'].includes(typeof val)) {
                prev.push(`${prefix}=${encodeURIComponent(val)}`);
                return prev;
            }

            prev.push(Object.keys(val).reduce(reducer(val, prefix), []).join('&'));
            return prev;
        };

        return Object.keys(initialObj).reduce(reducer(initialObj), []).join('&');
    };

    static platformHasImage(settingKey) {
        if (!laravel.platform_settings[settingKey]) {
            return false;
        }

        let imagePath = laravel.platform_settings[settingKey];

        return TB.isString(imagePath)
            && imagePath.length > 0;
    };

    static logoImagePath() {
        return laravel.platform_settings.Asset_Logo_Image
            || '/images/wripple_logo.png';
    };

    static logoBrandImagePath() {
        return laravel.platform_settings.Asset_Logo_Brand_Image
            || '/images/logo.png';
    };

    static logoEstimateIconPath() {
        return laravel.platform_settings.Asset_Logo_Estimate_Icon;
        // return laravel.platform_settings.Asset_Logo_Estimate_Icon
        //     || '/images/wripple_logo.png';
    };

    static defaultUserProfileImagePath() {
        return laravel.platform_settings.Asset_Default_User_Profile_Image
            || '/images/alt_user.png';
    };

    static metricTopRankIconPath() {
        return laravel.platform_settings.Asset_Metric_Top_Rank_Icon
            || '/images/highest-rank.png';
    };

    static defaultClientLogoImage() {
        return laravel.platform_settings.Asset_Default_Client_Logo_Image
    }

    static defaultClientBannerImage() {
        return laravel.platform_settings.Asset_Default_Client_Banner_Image
    }

    static defaultUserProfileImage() {
        return laravel.platform_settings.Asset_Default_User_Profile_Image
    }

    static defaultTalentBannerImage() {
        return laravel.platform_settings.Asset_Default_Talent_Banner_Image
    }
    static defaultClientPercentMarkup() {
        return laravel.platform_settings.Platform_1099_Time_Materials_Hourly_Percent_Markup
    }

    static orderedTimeZones() {
        let timezoneQuestions = TB.values(laravel.talent_questions.time_zones);
        let ordering = ['Eastern','Central', 'Mountain', 'Pacific','Atlantic',  'Hawaii', 'Alaska']
        timezoneQuestions = TB.orderBy(
            timezoneQuestions,
            zone => ordering.indexOf(zone.name),
            'asc'
        );
        return  TB.map(timezoneQuestions, zone => {
                return {
                    ...zone,
                    name: zone.name,
                    value: zone.id
                }
            }
        );
    }

    static TimeZonesSplit() {
        let splitTZs = TB.partition(this.orderedTimeZones(), ['is_in_us', true]);

        return [
            {
                name: 'U.S. Timezones',
                options:  splitTZs[0]
            },

            {
                name: 'Global',
                options:  TB.orderBy(splitTZs[1], 'id', 'desc')
            }
        ]
    }

    static TimeZonesInUS() {
        return TB.filter(this.orderedTimeZones(), ['is_in_us', true]);
    }
    static TimeZonesNotInUS() {
        return TB.filter(this.orderedTimeZones(), ['is_in_us', false]);
    }

    static isLocalEnv() {
        return process.env.APP_ENV === 'local';
    }

    static locationGlobalSetting() {

        return parseInt(TB.invert(laravel.project_visibility_location_settings)['Global'])
    }
    static locationRegionalSetting() {
        return parseInt(TB.invert(laravel.project_visibility_location_settings)['Regional'])
    }
    static locationProximitySetting() {
        return 4
    }

    static getGEOPosition(options) {
        return new Promise((resolve, reject) => {
            if ("geolocation" in navigator) {
                // Geolocation is available
                navigator.geolocation.getCurrentPosition(function(position) {
                    let latitude = position.coords.latitude;
                    let longitude = position.coords.longitude;
                    // console.log("Latitude: " + latitude + ", Longitude: " + longitude);

                    return resolve({latitude, longitude})
                    // You can do whatever you want with latitude and longitude here
                });
            } else {
              resolve(false)
                // Geolocation is not available
                console.log("Geolocation is not supported by your browser");
            }
        });
    }
    static impersonateUser(user_id) {

        if (this.isLocalEnv()) {
            return false;
        }

        return (
            <a href={`/impersonating/user/${user_id.id}?redirect_url=/talent/teams/all`}>
                Impersonate
            </a>
        );
    }
    static parseRequestError(request, appendErrorKey)
    {
        let statusCode = request?.statusCode() || 403,
            errorKey = request?.errorMessage?.();
        if (!TB.trans(`api`)[errorKey]) {
            errorKey = 'server_error';
        }


        let titleLines = [
            TB.trans(`api.${errorKey}.title`),
        ];


        if (TB.isObject(appendErrorKey)) {
            appendErrorKey = appendErrorKey[statusCode]
                ? appendErrorKey[statusCode]
                : appendErrorKey[500];
        }

        if (appendErrorKey && TB.trans(`api`)[appendErrorKey]) {
            titleLines.push(TB.trans(`api.${appendErrorKey}`))
        }

        return {
            title: titleLines,
            message: TB.trans(`api.${errorKey}.message`, {code: statusCode || ''}),
        };
    }
    static isValidUrl(str) {
        try {
            const url = new URL(str);

            // Check protocol
            if (url.protocol !== 'http:' && url.protocol !== 'https:') {
                return false;
            }

            // Check for valid hostname (at least one dot and valid characters)
            if (!url.hostname || !url.hostname.includes('.') || !/^[a-zA-Z0-9.-]+$/.test(url.hostname)) {
                return false;
            }

            // Check for valid TLD (at least 2 characters after last dot)
            const tld = url.hostname.split('.').pop();
            if (tld.length < 2) {
                return false;
            }

            return true;
        } catch {
            return false;
        }
    }

    static isValidURLFormat = (string) => {
        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/;
        return urlPattern.test(string);
    }
    /*
    * Timezone Helpers
    * */
    static TimeZoneOptions = [
        {
            name: "GMT/UTC",
            full_name: "Etc/UTC",
            abbreviations: ["GMT", "UTC"],
            short: "UTC"
        },
        {
            name: "European Central",
            full_name: "Europe/Berlin",
            abbreviations: ["CET", "CEST"],
            short: "CET"
        },
        {
            name: "Eastern European",
            full_name: "Europe/Helsinki",
            abbreviations: ["EET", "EEST"],
            short: "EET"
        },
        {
            name: "Eastern African",
            full_name: "Africa/Nairobi",
            abbreviations: ["EAT"],
            short: "EAT"
        },
        {
            name: "Middle East",
            full_name: "Asia/Beirut",
            abbreviations: ["MST", "MSDT"],
            short: "MST"
        },
        {
            name: "Near East",
            full_name: "Asia/Amman",
            abbreviations: ["NET"],
            short: "NET"
        },
        {
            name: "Pakistan Lahore",
            full_name: "Asia/Karachi",
            abbreviations: ["PKT"],
            short: "PKT"
        },
        {
            name: "India",
            full_name: "Asia/Kolkata",
            abbreviations: ["IST"],
            short: "IST"
        },
        {
            name: "Bangladesh",
            full_name: "Asia/Dhaka",
            abbreviations: ["BDT"],
            short: "BDT"
        },
        {
            name: "Vietnam",
            full_name: "Asia/Ho_Chi_Minh",
            abbreviations: ["ICT"],
            short: "ICT"
        },
        {
            name: "China Taiwan",
            full_name: "Asia/Shanghai",
            abbreviations: ["CST"],
            short: "CST"
        },
        {
            name: "Japan",
            full_name: "Asia/Tokyo",
            abbreviations: ["JST"],
            short: "JST"
        },
        {
            name: "Australia Central",
            full_name: "Australia/Adelaide",
            abbreviations: ["ACST", "ACDT"],
            short: "ACST"
        },
        {
            name: "Australia Eastern",
            full_name: "Australia/Sydney",
            abbreviations: ["AEST", "AEDT"],
            short: "AEST"
        },
        {
            name: "Solomon",
            full_name: "Pacific/Guadalcanal",
            abbreviations: ["SBT"],
            short: "SBT"
        },
        {
            name: "New Zealand",
            full_name: "Pacific/Auckland",
            abbreviations: ["NZST", "NZDT"],
            short: "NZST"
        },
        {
            name: "Samoa",
            full_name: "Pacific/Apia",
            abbreviations: ["SST", "SDT"],
            short: "SST"
        },
        {
            name: "Hawaii",
            full_name: "Pacific/Honolulu",
            abbreviations: ["HST"],
            short: "HST"
        },
        {
            name: "Alaska",
            full_name: "America/Anchorage",
            abbreviations: ["AKST", "AKDT"],
            short: "AKST"
        },
        {
            name: "Pacific",
            full_name: "America/Los_Angeles",
            abbreviations: ["PST", "PDT"],
            short: "PST"
        },
        {
            name: "Mountain",
            full_name: "America/Denver",
            abbreviations: ["MST", "MDT"],
            short: "MST"
        },
        {
            name: "Central",
            full_name: "America/Chicago",
            abbreviations: ["CST", "CDT"],
            short: "CST"
        },
        {
            name: "Eastern",
            full_name: "America/New_York",
            abbreviations: ["EST", "EDT"],
            short: "EST"
        },
        {
            name: "Atlantic",
            full_name: "America/Halifax",
            abbreviations: ["AST", "ADT"],
            short: "AST"
        },
        {
            name: "Canada Newfoundland",
            full_name: "America/St_Johns",
            abbreviations: ["NST", "NDT"],
            short: "NST"
        },
        {
            name: "Brazil Eastern",
            full_name: "America/Sao_Paulo",
            abbreviations: ["BRT", "BRST"],
            short: "BRT"
        },
        {
            name: "Central African",
            full_name: "Africa/Harare",
            abbreviations: ["CAT"],
            short: "CAT"
        }
    ];

    static guessUserTimezone = () => {
        return TB.moment.tz.guess()
    }

    // static applyTimezoneToDateTime = (date, timezone) => {
    //     return TB.moment(date).tz(timezone).format()
    // }

    static getTimezoneFromOption = (timezoneOptionName) => {
        let selected =  TB.find(TB.TimeZoneOptions, ['name', timezoneOptionName]);

        if (!selected || !timezoneOptionName) {
            selected = TB.getDefaultTimezoneOption();
        }
        return selected?.full_name
    }
    static applyTimezoneToDateTime = (date, option, keepLocal = false) => {
        let selected =  TB.getTimezoneFromOption(option)
        return TB.moment(date).tz(selected, keepLocal)
    }

    static applyTimezoneOptionToDateTime = (date, timezoneOptionName) => {
        let selected =  TB.getTimezoneFromOption(timezoneOptionName)
        return TB.moment(date).tz(selected).format()
    }

    static getDefaultTimezoneOption = () => {
        let abbr = TB.moment.tz(TB.moment.tz.guess()).format('z');
        if (!abbr) {
            return false
        }
        return TB.find(TB.TimeZoneOptions,zone => zone.abbreviations.includes(abbr))
    }

    static getTimezoneAbbrFromOption = (date,option) => {
        let selected =  TB.getTimezoneFromOption(option)


        // if (TB.moment(date).tz(selected?.full_name).isDST()) {
        //     return TB.moment(date).month(0).tz(selected?.full_name).format('z')
        // }
        return TB.moment(date).tz(selected).format('z')
    }


}

/**
 * [Note]
 *
 * @param {Object} config
 * @returns void
 */
const boot = function (config) {
    TB.boot(config);

    global.TB = TB;
};

export default boot;